export function raitingStars() {

    let raiting = $("[data-raiting]").attr("data-raiting");
    let starWidth = 17.5;
    let starIndent = 10.5;

    if (raiting) {
        let index = Number(raiting);
        let $stars = $(".raiting-active");

        if (index < 1) {
            $stars.addClass("small-raiting");

            $stars.css({
                width: (starWidth * index) + "px"
            });
        } else {

            if (index === 5) {
                $stars.css({
                    width: (starWidth * index) + starIndent * (Math.floor(index) - 1) + "px"
                });
            } else {
                $stars.css({
                    width: (starWidth * index) + starIndent * Math.floor(index) + "px"
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/raitingStars.js